













/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import { DEFAULT_DATE_FORMAT } from '@root/common/config';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
import { DEVICE_LIST } from '../router-names';
// axios请求
import { editInfoDeviceList } from '@/api/parking-lot-management/index';
import { IFieldInfoListItem } from '@root/types/component';
// import FieldInfoList from '@root/frame/src/components/field-info-list/index.vue'

@Component
export default class DeviceListDetail extends Mixins(GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/device-list/';

  deviceId = '';
  detailList = {};
  headTitle = '设备详情';
  headertitle = '';
  detailModel: any = {};
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '设备信息',
        location: {
          name: DEVICE_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  deviceListForm: IFieldInfoListItem[] = [
    {
      prop: 'typeDesc',
      label: '设备类型 ：'
    },
    {
      prop: 'parkName',
      label: '所属车场 ：'
    },
    {
      prop: 'brandDesc',
      label: '设备品牌 ：'
    },
    {
      prop: 'ip',
      label: '设备IP ：'
    },
    {
      prop: 'port',
      label: '设备端口 ：'
    },
    {
      prop: 'connectTypeDesc',
      label: '设备连接方式 ：'
    },
    {
      prop: 'connectSourceDesc',
      label: '设备连接源 ：'
    },
    {
      prop: 'deviceVersionDesc',
      label: '驱动版本 ：'
    },
    {
      prop: 'priority',
      label: '优先级 ：'
    },

    {
      prop: 'statusDesc',
      label: '设备状态 ：'
    },
    {
      prop: 'isSupportTtsDesc',
      label: '是否支持万能语音 ：'
    },
    {
      prop: 'deviceCode',
      label: '设备编号 ：'
    }
  ];
  created() {
    console.log(this.$route.params.deviceId);
    this.deviceId = this.$route.params.deviceId;
    this.renderDetail(this.$route.params.deviceId);
  }
  async renderDetail(deviceId: string) {
    try {
      const { status, msg, code, data } = await editInfoDeviceList({ deviceId });
      if (status === '9999') {
        this.detailList = data;
        this.headertitle = data.name;
      }
      // console.log(status, msg, code, data)
      // this.detailList = datas
    } catch (error) {
      console.log(error);
    }
  }
  // // 返回
  // goBack() {
  //   this.$router.replace({
  //     name: DEVICE_LIST,
  //   })
  // }
}
